<a
  data-track-group="Logo"
  data-track
  class="logo-link"
  [class.logo-link--default]="size === sizes.Default"
  [class.logo-link--full-width]="size === sizes.FullWidth"
  [class.logo-link--wave-only]="size === sizes.WaveOnly"
  title="For The Record home page"
  [routerLink]="['/']"
>
  <img class="logo" alt="For The Record logo" src="{{ theme | themedLogoPath }}" />
</a>
